/**
 * Mobile Menu Toggle
 * ==================
 * Toggles the .gh-head-open class on <body> when the burger menu is clicked.
 * Matches the Ghost Starter theme behavior.
 */

export default function menuOpen() {
    const burger = document.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', () => {
        document.body.classList.toggle('gh-head-open');
    });

    // Close menu when pressing Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('gh-head-open')) {
            document.body.classList.remove('gh-head-open');
        }
    });

    // Close menu when clicking a nav link (on mobile)
    const navLinks = document.querySelectorAll('.gh-head-menu .nav a');
    navLinks.forEach((link) => {
        link.addEventListener('click', () => {
            document.body.classList.remove('gh-head-open');
        });
    });
}
